// lib/donations/donationCharge.ts
import { netToCard } from "@/lib/utils/pricing"

/**
 * Monto a COBRAR por una donación, partiendo del monto a-la-causa que el donante eligió.
 * El donante paga el costo de procesamiento: en tarjeta/split la donación se grossea con
 * el pct de dual pricing (igual que los precios), así al merchant le llega el monto íntegro;
 * en efectivo no hay fee y el cargo == el monto a-la-causa.
 *
 * @param amount monto a-la-causa en dólares (lo que el donante eligió / lo que se remite)
 * @param paymentMethod método de pago de la orden
 * @param cashDiscountPct pct de dual pricing del local (default 0.04)
 */
export function donationCharge(
  amount: number,
  paymentMethod: "cash" | "card" | "split",
  cashDiscountPct: number,
): number {
  if (!(amount > 0)) return 0
  // El donante paga el fee (decisión 2026-06-28): en efectivo el cargo == el monto
  // a-la-causa; en tarjeta/split se grossea con el pct de dual pricing para que al
  // merchant le llegue el monto íntegro. El botón de redondeo puede dejar el total
  // off por centavos — aceptado.
  if (paymentMethod === "cash") return Math.round(amount * 100) / 100
  return netToCard(amount, cashDiscountPct)
}
